import Icon from "@ant-design/icons";
import React from "react";

export default function AttachmentIcon() {
  return <Icon className="ac-icon" component={IconSvg} />;
}

const IconSvg = () => {
  return (
    <svg height="1em" viewBox="0 0 24 24" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.6663 5.39104C16.8532 4.53632 15.5376 4.53632 14.7245 5.39104L7.50313 12.9819C6.13901 14.4158 6.13901 16.7435 7.50313 18.1774C8.86364 19.6075 11.0667 19.6075 12.4273 18.1774L19.6486 10.5865C19.9285 10.2923 20.3844 10.2901 20.6668 10.5817C20.9493 10.8733 20.9514 11.3481 20.6715 11.6424L13.4501 19.2332C11.5262 21.2556 8.40419 21.2556 6.48028 19.2332C4.55996 17.2146 4.55996 13.9447 6.48028 11.9261L13.7016 4.33521C15.0781 2.88826 17.3126 2.88826 18.6891 4.33521C20.062 5.77838 20.062 8.11542 18.6891 9.55858L11.751 16.8518C10.9219 17.7233 9.5749 17.7233 8.7458 16.8518C7.92029 15.984 7.92029 14.5799 8.7458 13.7122L14.8344 7.31202C15.1143 7.0178 15.5702 7.01565 15.8526 7.30721C16.1351 7.59877 16.1371 8.07364 15.8572 8.36786L9.76865 14.768C9.49934 15.0511 9.49934 15.5129 9.76865 15.7959C10.0344 16.0752 10.4624 16.0752 10.7281 15.7959L17.6663 8.50275C18.483 7.64425 18.483 6.24954 17.6663 5.39104Z"
        fill="currentColor"
      />
    </svg>
  );
};
